import { render, staticRenderFns } from "./ExerciseConfig.vue?vue&type=template&id=30081840"
import script from "./ExerciseConfig.vue?vue&type=script&lang=js"
export * from "./ExerciseConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports